import {
    createFeatureSelector,
    createSelector
} from '@ngrx/store';
import { StateSlice } from '../state-slice';
import { IToastState } from './toast.state';

export const selectToastState = createFeatureSelector<IToastState>(StateSlice.TOAST);

/**
 * Returns all toast messages.
 * @param state
 */
export const getToasts = createSelector(selectToastState, (state: IToastState) => {
    return state && state.toast;
});